import React from "react";
import { Col, Row } from "react-bootstrap";
import StarRating from "./StarComp";

// this counter component is used for the customer and driver details both

const CustomerCounter = ({ isCustomer, customerData, driverData }) => {
  const averageRating = customerData?.averageRating ?? "";
  // const averageRating = 2.5;
  return (
    <>
      {isCustomer && (
        <Row>
          <Col lg="4" sm="6" className="my-2">
            <div className="cardCstm border rounded p-3 h-100 d-flex align-items-center justify-content-between gap-10">
              <div className="left">
                <p className="text-muted m-0 fw-sbold pb-2">
                  Average Ratings Received
                </p>
                <h4 className="m-0 text-muted m-0 pt-2 fw-bold d-flex align-items-center">
                  {/* {customerData?.averageRating ?? ""}  */}
                  {/* <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center ms-2">
                    <li className="">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="21"
                        height="20"
                        viewBox="0 0 21 20"
                        fill="none"
                      >
                        <path
                          d="M10.6024 3.12087C10.2976 3.30557 9.91542 3.30554 9.61064 3.12082L4.93617 0.287591C4.21164 -0.151551 3.31596 0.498181 3.50848 1.32324L4.74776 6.63416C4.82827 6.97918 4.71153 7.34044 4.44435 7.57312L0.32977 11.1563C-0.307574 11.7113 0.0350516 12.7597 0.877163 12.8312L6.29958 13.2917C6.65268 13.3216 6.96029 13.5443 7.09903 13.8704L9.22706 18.8719C9.55734 19.6482 10.6576 19.6482 10.9879 18.8719L13.1159 13.8704C13.2546 13.5443 13.5623 13.3216 13.9154 13.2917L19.3378 12.8312C20.1799 12.7597 20.5225 11.7113 19.8852 11.1563L15.7706 7.57312C15.5034 7.34044 15.3867 6.97918 15.4672 6.63416L16.7065 1.32287C16.8991 0.497866 16.0035 -0.151863 15.2789 0.287164L10.6024 3.12087Z"
                          fill="#FFC500"
                        />
                      </svg>
                    </li>
                    <li className="">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="21"
                        height="20"
                        viewBox="0 0 21 20"
                        fill="none"
                      >
                        <path
                          d="M10.6024 3.12087C10.2976 3.30557 9.91542 3.30554 9.61064 3.12082L4.93617 0.287591C4.21164 -0.151551 3.31596 0.498181 3.50848 1.32324L4.74776 6.63416C4.82827 6.97918 4.71153 7.34044 4.44435 7.57312L0.32977 11.1563C-0.307574 11.7113 0.0350516 12.7597 0.877163 12.8312L6.29958 13.2917C6.65268 13.3216 6.96029 13.5443 7.09903 13.8704L9.22706 18.8719C9.55734 19.6482 10.6576 19.6482 10.9879 18.8719L13.1159 13.8704C13.2546 13.5443 13.5623 13.3216 13.9154 13.2917L19.3378 12.8312C20.1799 12.7597 20.5225 11.7113 19.8852 11.1563L15.7706 7.57312C15.5034 7.34044 15.3867 6.97918 15.4672 6.63416L16.7065 1.32287C16.8991 0.497866 16.0035 -0.151863 15.2789 0.287164L10.6024 3.12087Z"
                          fill="#FFC500"
                        />
                      </svg>
                    </li>
                    <li className="">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="21"
                        height="20"
                        viewBox="0 0 21 20"
                        fill="none"
                      >
                        <path
                          d="M10.6024 3.12087C10.2976 3.30557 9.91542 3.30554 9.61064 3.12082L4.93617 0.287591C4.21164 -0.151551 3.31596 0.498181 3.50848 1.32324L4.74776 6.63416C4.82827 6.97918 4.71153 7.34044 4.44435 7.57312L0.32977 11.1563C-0.307574 11.7113 0.0350516 12.7597 0.877163 12.8312L6.29958 13.2917C6.65268 13.3216 6.96029 13.5443 7.09903 13.8704L9.22706 18.8719C9.55734 19.6482 10.6576 19.6482 10.9879 18.8719L13.1159 13.8704C13.2546 13.5443 13.5623 13.3216 13.9154 13.2917L19.3378 12.8312C20.1799 12.7597 20.5225 11.7113 19.8852 11.1563L15.7706 7.57312C15.5034 7.34044 15.3867 6.97918 15.4672 6.63416L16.7065 1.32287C16.8991 0.497866 16.0035 -0.151863 15.2789 0.287164L10.6024 3.12087Z"
                          fill="#FFC500"
                        />
                      </svg>
                    </li>
                    <li className="">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="21"
                        height="20"
                        viewBox="0 0 21 20"
                        fill="none"
                      >
                        <g clip-path="url(#clip0_22_5773)">
                          <path
                            d="M10.724 3.12087C10.4192 3.30557 10.037 3.30554 9.73223 3.12082L5.05775 0.287591C4.33322 -0.151551 3.43754 0.498181 3.63006 1.32324L4.86934 6.63416C4.94985 6.97918 4.83311 7.34044 4.56593 7.57312L0.451352 11.1563C-0.185992 11.7113 0.156634 12.7597 0.998745 12.8312L6.42116 13.2917C6.77426 13.3216 7.08187 13.5443 7.22061 13.8704L9.34864 18.8719C9.67892 19.6482 10.7792 19.6482 11.1095 18.8719L13.2375 13.8704C13.3762 13.5443 13.6838 13.3216 14.0369 13.2917L19.4594 12.8312C20.3015 12.7597 20.6441 11.7113 20.0067 11.1563L15.8922 7.57312C15.625 7.34044 15.5083 6.97918 15.5888 6.63416L16.8281 1.32287C17.0206 0.497866 16.1251 -0.151863 15.4005 0.287164L10.724 3.12087Z"
                            fill="#E0E8F1"
                          />
                          <mask
                            id="mask0_22_5773"
                            style={{ maskType: "alpha" }}
                            maskUnits="userSpaceOnUse"
                            x="0"
                            y="0"
                            width="21"
                            height="20"
                          >
                            <path
                              d="M10.724 3.12087C10.4192 3.30557 10.037 3.30554 9.73223 3.12082L5.05775 0.287591C4.33322 -0.151551 3.43754 0.498181 3.63006 1.32324L4.86934 6.63416C4.94985 6.97918 4.83311 7.34044 4.56593 7.57312L0.451352 11.1563C-0.185992 11.7113 0.156634 12.7597 0.998745 12.8312L6.42116 13.2917C6.77426 13.3216 7.08187 13.5443 7.22061 13.8704L9.34864 18.8719C9.67892 19.6482 10.7792 19.6482 11.1095 18.8719L13.2375 13.8704C13.3762 13.5443 13.6838 13.3216 14.0369 13.2917L19.4594 12.8312C20.3015 12.7597 20.6441 11.7113 20.0067 11.1563L15.8922 7.57312C15.625 7.34044 15.5083 6.97918 15.5888 6.63416L16.8281 1.32287C17.0206 0.497866 16.1251 -0.151863 15.4005 0.287164L10.724 3.12087Z"
                              fill="#E0E8F1"
                            />
                          </mask>
                          <g mask="url(#mask0_22_5773)">
                            <rect
                              width="10.1075"
                              height="19.3061"
                              transform="matrix(1 0 0 -1 0.121582 19.4541)"
                              fill="#FFC500"
                            />
                          </g>
                        </g>
                        <defs>
                          <clipPath id="clip0_22_5773">
                            <rect
                              width="20.2149"
                              height="19.3726"
                              fill="white"
                              transform="matrix(1 0 0 -1 0.121582 19.4541)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                    </li>
                    <li className="">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="22"
                        height="20"
                        viewBox="0 0 22 20"
                        fill="none"
                      >
                        <g clip-path="url(#clip0_22_5777)">
                          <path
                            d="M11.431 3.49587C11.1262 3.68057 10.744 3.68054 10.4393 3.49582L5.76478 0.662591C5.04025 0.223449 4.14457 0.873181 4.33709 1.69824L5.57637 7.00916C5.65688 7.35418 5.54014 7.71544 5.27296 7.94812L1.15838 11.5313C0.521039 12.0863 0.863665 13.1347 1.70578 13.2062L7.12819 13.6667C7.48129 13.6966 7.7889 13.9193 7.92765 14.2454L10.0557 19.2469C10.386 20.0232 11.4862 20.0232 11.8165 19.2469L13.9445 14.2454C14.0833 13.9193 14.3909 13.6966 14.744 13.6667L20.1664 13.2062C21.0085 13.1347 21.3511 12.0863 20.7138 11.5313L16.5992 7.94812C16.332 7.71544 16.2153 7.35418 16.2958 7.00916L17.5352 1.69787C17.7277 0.872866 16.8321 0.223137 16.1076 0.662164L11.431 3.49587Z"
                            fill="#E0E8F1"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_22_5777">
                            <rect
                              width="20.2149"
                              height="19.3726"
                              fill="white"
                              transform="matrix(1 0 0 -1 0.828613 19.4541)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                    </li>
                  </ul> */}
                  {/* {customerData?.averageRating ?? ""} */}
                  {/* ....Star Rating based on number type.... */}
                  {/* {averageRating} */}
                  <StarRating averageRating={averageRating} />
                </h4>
              </div>
              <div className="imgWrp">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="40"
                  height="40"
                  viewBox="0 0 56 50"
                  fill="none"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M39.2375 49C40.7495 49 44.7815 47.5006 43.4375 46.3225C43.3255 46.2689 43.2695 46.2154 43.2135 46.1618V21.1003C43.7735 20.8326 43.8855 19.9222 43.1575 19.708C32.8536 16.495 27.3657 14.353 24.3978 3.58942C22.4938 -3.74696 10.2859 -0.212643 19.6378 17.6731H5.41402C0.822086 17.6731 -1.02589 23.4566 2.83805 25.8663C0.0380974 27.6335 0.0380974 31.5426 2.83805 33.3098C0.0380974 35.0769 0.0380974 39.0397 2.83805 40.8068C-1.02589 43.2166 0.822086 49 5.41402 49H39.2375Z"
                    fill="#FFC3A1"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M45.485 50H50.3604C53.0751 50 55.2358 47.824 55.2358 45.1584V20.8416C55.2358 18.176 53.0751 16.0544 50.3604 16.0544L45.485 16C43.9337 16 42.6594 17.2512 42.6594 18.7744V47.2256C42.6594 48.7488 43.9337 50 45.485 50Z"
                    fill="#2882B0"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M48.968 46C53.1331 46 53.1331 40 48.968 40C44.7488 40 44.7488 46 48.968 46Z"
                    fill="#20698E"
                  />
                </svg>
              </div>
            </div>
          </Col>
          <Col lg="4" sm="6" className="my-2">
            <div className="cardCstm border rounded p-3 h-100 d-flex align-items-center justify-content-between gap-10">
              <div className="left">
                <p className="text-muted m-0 fw-sbold pb-2">
                  Booking completed
                </p>
                <h4 className="m-0 text-muted m-0 pt-2 fw-bold d-flex align-items-center">
                  {customerData?.totalBookingsCompleted ?? ""}
                </h4>
              </div>
              <div className="imgWrp">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="40"
                  height="40"
                  viewBox="0 0 55 54"
                  fill="none"
                >
                  <path
                    d="M27.4102 54C12.4985 54 0.410156 41.9117 0.410156 27C0.410156 12.0883 12.4985 0 27.4102 0C42.3218 0 54.4102 12.0883 54.4102 27C54.4102 41.9117 42.3218 54 27.4102 54Z"
                    fill="#6DC871"
                  />
                  <path
                    d="M38.7619 15.3211C39.1983 14.893 39.9058 14.893 40.3422 15.3211L45.0829 19.9725C45.5192 20.4006 45.5192 21.0948 45.0829 21.5229L24.5398 41.6789C24.1034 42.107 23.3959 42.107 22.9596 41.6789L8.73743 27.7248C8.30106 27.2966 8.30106 26.6025 8.73743 26.1743L13.4781 21.5229C13.9145 21.0948 14.622 21.0948 15.0584 21.5229L23.7497 30.0505L38.7619 15.3211Z"
                    fill="white"
                  />
                </svg>
              </div>
            </div>
          </Col>
          <Col lg="4" sm="6" className="my-2">
            <div className="cardCstm border rounded p-3 h-100 d-flex align-items-center justify-content-between gap-10">
              <div className="left">
                <p className="text-muted m-0 fw-sbold pb-2">
                  Total Amount Spent
                </p>
                <h4 className="m-0 text-muted m-0 pt-2 fw-bold d-flex align-items-center">
                  ${customerData?.totalAmountSpent ?? ""}
                </h4>
              </div>
              <div className="imgWrp">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="40"
                  height="40"
                  viewBox="0 0 60 50"
                  fill="none"
                >
                  <path
                    d="M59.3748 34.0859L59.356 39.7263L41.6777 49.9997L41.6965 44.3595L59.3748 34.0859Z"
                    fill="#5EAF5F"
                  />
                  <path
                    d="M41.6963 44.3593L41.6775 49.9995L0 25.9371L0.0189257 20.2969L41.6963 44.3593Z"
                    fill="#7BC578"
                  />
                  <path
                    d="M59.3748 34.0859L41.6965 44.3594L0.019043 20.297L17.6973 10.0234L59.3748 34.0859Z"
                    fill="#98D095"
                  />
                  <path
                    d="M44.2636 33.0662L43.7823 33.3459C44.2079 33.729 44.2107 34.1937 43.7365 34.4693L43.1178 34.1121C43.3328 33.9871 43.227 33.7031 42.8916 33.5094C42.5487 33.3115 42.0581 33.2511 41.8431 33.3761C41.6285 33.5008 41.7339 33.785 42.0768 33.9831C42.77 34.3832 42.8703 34.9726 42.3073 35.2998C41.8332 35.5754 41.0309 35.5753 40.3754 35.3258L39.894 35.6055L39.2754 35.2484L39.7567 34.9686C39.3239 34.5897 39.321 34.1249 39.7952 33.8495L40.4139 34.2067C40.1989 34.3316 40.3119 34.6113 40.6547 34.8094C40.9902 35.0031 41.4736 35.0675 41.6886 34.9426C41.9108 34.8134 41.7975 34.5339 41.462 34.3403C40.7688 33.94 40.6614 33.346 41.2244 33.0188C41.6985 32.7434 42.5008 32.7435 43.1636 32.9888L43.6449 32.709L44.2636 33.0662Z"
                    fill="#46A046"
                  />
                  <path
                    d="M20.1187 19.1258L19.6373 19.4055C20.0629 19.7886 20.0732 20.2576 19.5991 20.5331L18.9729 20.1715C19.1878 20.0467 19.0895 19.7669 18.7467 19.569C18.4038 19.371 17.9131 19.3107 17.6982 19.4357C17.4836 19.5603 17.5889 19.8446 17.9319 20.0425C18.6251 20.4428 18.7328 21.0365 18.1699 21.3636C17.6957 21.6392 16.8859 21.6349 16.2304 21.3854L15.7491 21.665L15.1304 21.3078L15.6118 21.0281C15.1789 20.6492 15.1761 20.1845 15.6503 19.9089L16.269 20.2662C16.054 20.3911 16.167 20.6709 16.5098 20.8689C16.8527 21.0668 17.3287 21.1271 17.5437 21.0022C17.7659 20.873 17.66 20.5978 17.3171 20.3997C16.6238 19.9995 16.5165 19.4056 17.0795 19.0784C17.5536 18.8029 18.3559 18.8029 19.0185 19.0482L19.5 18.7686L20.1187 19.1258Z"
                    fill="#46A046"
                  />
                  <path
                    d="M19.4174 13.3761C20.3642 13.9227 20.3691 14.8006 19.4285 15.3474C18.4956 15.8895 16.9722 15.8938 16.0255 15.3474C15.0863 14.8051 15.0815 13.9184 16.0144 13.3761C16.955 12.8295 18.4782 12.8338 19.4174 13.3761Z"
                    fill="#46A046"
                  />
                  <path
                    d="M35.8565 24.4976L34.6644 25.1904C35.7245 26.1288 35.7312 27.2735 34.5534 27.9579L33.0253 27.0755C33.5584 26.7657 33.2945 26.0729 32.4521 25.5865C31.6172 25.1044 30.4127 24.9496 29.8795 25.2593C29.3464 25.5692 29.6178 26.2663 30.4528 26.7484C32.1672 27.7383 32.428 29.193 31.0357 30.0021C29.8657 30.6821 27.8818 30.6864 26.266 30.071L25.0662 30.7681L23.5381 29.8859L24.7378 29.1887C23.6701 28.2547 23.6636 27.1013 24.8337 26.4213L26.3618 27.3036C25.8286 27.6135 26.1001 28.3107 26.9351 28.7927C27.7773 29.279 28.9743 29.4297 29.5076 29.1199C30.0407 28.81 29.7768 28.1171 28.9344 27.6308C27.2274 26.6452 26.9664 25.182 28.3514 24.3771C29.5291 23.6927 31.5127 23.6971 33.1362 24.3081L34.3283 23.6152L35.8565 24.4976Z"
                    fill="#46A046"
                  />
                  <path
                    d="M9.20469 19.3117C10.1513 19.8583 10.1563 20.7362 9.21607 21.2826C8.28277 21.825 6.76699 21.825 5.82033 21.2785C4.8811 20.7362 4.86861 19.8539 5.80202 19.3114C6.74225 18.7651 8.26545 18.7694 9.20469 19.3117Z"
                    fill="#46A046"
                  />
                  <path
                    d="M53.5734 33.0956C54.5201 33.6422 54.5251 34.5203 53.5845 35.0669C52.6514 35.609 51.1281 35.6135 50.1815 35.0669C49.2422 34.5246 49.2448 33.6422 50.1777 33.1C51.1185 32.5533 52.6341 32.5533 53.5734 33.0956Z"
                    fill="#46A046"
                  />
                  <path
                    d="M43.3606 39.0312C44.3073 39.5778 44.3122 40.4558 43.372 41.0022C42.4387 41.5446 40.9229 41.5446 39.9763 40.998C39.037 40.4557 39.0319 39.5777 39.9654 39.0353C40.9056 38.4889 42.4213 38.4889 43.3606 39.0312Z"
                    fill="#46A046"
                  />
                  <path
                    d="M17.7137 11.6377L56.5882 34.0819L41.6875 42.7412L25.6756 33.4967L2.81299 20.297L17.7137 11.6377ZM22.2912 31.4911C26.406 33.8667 33.0708 33.8624 37.1514 31.491C41.2321 29.1196 41.2179 25.259 37.1031 22.8834C32.9956 20.512 26.3234 20.512 22.2427 22.8834C18.1621 25.2548 18.1837 29.1197 22.2912 31.4911ZM9.73026 21.5708L18.1611 26.4039C18.4351 24.9494 19.5269 23.5376 21.4451 22.4229C23.3633 21.3081 25.7892 20.6756 28.3072 20.5076L19.9062 15.6572C21.1501 14.9343 21.1439 13.7894 19.9214 13.0836C18.7063 12.3821 16.7222 12.3779 15.5075 13.0837C14.293 13.7897 14.3142 14.9345 15.5293 15.636L9.74572 19.0402C8.49341 18.3171 6.50931 18.313 5.30227 19.0144C4.08051 19.7245 4.10179 20.8693 5.31687 21.5708C6.53937 22.2766 8.50838 22.281 9.73026 21.5708ZM43.8645 38.7386L49.6555 35.3387C50.9078 36.0617 52.8768 36.066 54.0914 35.3602C55.3061 34.6543 55.2999 33.5093 54.0773 32.8035C52.8623 32.102 50.8857 32.1022 49.671 32.8081L41.2406 27.9747C40.9514 29.4296 39.8672 30.8367 37.949 31.9515C36.0309 33.0662 33.5974 33.7032 31.0944 33.871L39.4955 38.7214C38.2439 39.4488 38.2578 40.5893 39.4729 41.2907C40.6954 41.9966 42.6644 42.0009 43.8863 41.2909C45.0932 40.5894 45.087 39.4444 43.8645 38.7386ZM23.1004 15.5799L21.9971 16.2212L26.4995 18.8207L27.6028 18.1794L23.1004 15.5799ZM45.2623 28.3752L44.1589 29.0163L48.6539 31.6114L49.7573 30.9703L45.2623 28.3752ZM14.1389 26.0038L15.235 25.3667L10.7327 22.7673L9.63649 23.4043L14.1389 26.0038ZM36.2934 38.7947L37.3896 38.1576L32.8945 35.5625L31.7984 36.1995L36.2934 38.7947Z"
                    fill="#46A046"
                  />
                  <path
                    d="M42.9742 24.6175L25.2959 34.8909L24.4819 34.421L42.1602 24.1475L42.9742 24.6175Z"
                    fill="#86AEDC"
                  />
                  <path
                    d="M47.7223 27.3584L30.044 37.632L25.2959 34.8906L42.9742 24.6172L47.7223 27.3584Z"
                    fill="#E3E6F0"
                  />
                  <path
                    d="M48.5314 27.8255L30.853 38.099L30.0439 37.6319L47.7222 27.3584L48.5314 27.8255Z"
                    fill="#86AEDC"
                  />
                  <path
                    d="M25.2954 34.8906L25.2584 40.5325L24.4448 40.0628L24.4819 34.4209L25.2954 34.8906Z"
                    fill="#678CC8"
                  />
                  <path
                    d="M30.0396 37.6298L30.0025 43.2716L25.2583 40.5326L25.2953 34.8906L30.0396 37.6298Z"
                    fill="#D4DBE9"
                  />
                  <path
                    d="M30.853 38.0994L30.816 43.7414L30.0024 43.2717L30.0396 37.6299L30.853 38.0994Z"
                    fill="#678CC8"
                  />
                  <path
                    d="M59.3748 24.0625L59.356 29.7027L41.6777 39.9763L41.6965 34.336L59.3748 24.0625Z"
                    fill="#5EAF5F"
                  />
                  <path
                    d="M41.6963 34.336L41.6775 39.9762L0 15.9138L0.0189257 10.2734L41.6963 34.336Z"
                    fill="#7BC578"
                  />
                  <path
                    d="M59.3748 24.0624L41.6965 34.336L0.019043 10.2734L17.6973 0L59.3748 24.0624Z"
                    fill="#98D095"
                  />
                  <path
                    d="M44.2636 23.0428L43.7823 23.3225C44.2079 23.7056 44.2107 24.1703 43.7365 24.4458L43.1178 24.0886C43.3328 23.9637 43.227 23.6797 42.8916 23.486C42.5487 23.2881 42.0581 23.2277 41.8431 23.3526C41.6285 23.4773 41.7339 23.7616 42.0768 23.9595C42.77 24.3598 42.8703 24.9492 42.3073 25.2764C41.8332 25.5519 41.0309 25.5519 40.3754 25.3024L39.894 25.582L39.2754 25.2248L39.7567 24.9451C39.3239 24.5662 39.321 24.1015 39.7952 23.826L40.4139 24.1831C40.1989 24.3081 40.3119 24.5879 40.6547 24.7859C40.9902 24.9795 41.4736 25.0441 41.6886 24.9191C41.9108 24.79 41.7975 24.5105 41.462 24.3167C40.7688 23.9166 40.6614 23.3226 41.2244 22.9954C41.6985 22.7199 42.5008 22.7199 43.1636 22.9652L43.6449 22.6855L44.2636 23.0428Z"
                    fill="#46A046"
                  />
                  <path
                    d="M20.1187 9.10223L19.6373 9.38203C20.0629 9.765 20.0732 10.2341 19.5991 10.5097L18.9729 10.1481C19.1878 10.0232 19.0895 9.74348 18.7467 9.54556C18.4038 9.34752 17.9131 9.28728 17.6982 9.41222C17.4836 9.5369 17.5889 9.82103 17.9319 10.0191C18.6251 10.4194 18.7328 11.0131 18.1699 11.3402C17.6957 11.6158 16.8859 11.6113 16.2304 11.3618L15.7491 11.6416L15.1304 11.2844L15.6118 11.0046C15.1789 10.6258 15.1761 10.1611 15.6503 9.88548L16.269 10.2427C16.054 10.3677 16.167 10.6475 16.5098 10.8454C16.8527 11.0434 17.3287 11.1036 17.5437 10.9787C17.7659 10.8496 17.66 10.5742 17.3171 10.3763C16.6238 9.97603 16.5165 9.38203 17.0795 9.05498C17.5536 8.77938 18.3559 8.7795 19.0185 9.0248L19.5 8.74512L20.1187 9.10223Z"
                    fill="#46A046"
                  />
                  <path
                    d="M19.4174 3.35268C20.3642 3.8993 20.3691 4.77717 19.4285 5.32379C18.4956 5.86596 16.9722 5.87041 16.0255 5.32392C15.0863 4.78163 15.0815 3.89484 16.0144 3.35268C16.955 2.80606 18.4782 2.81039 19.4174 3.35268Z"
                    fill="#46A046"
                  />
                  <path
                    d="M35.8565 14.4741L34.6644 15.167C35.7245 16.1052 35.7312 17.25 34.5534 17.9343L33.0253 17.0521C33.5584 16.7422 33.2945 16.0494 32.4521 15.563C31.6172 15.081 30.4127 14.926 29.8795 15.2359C29.3464 15.5457 29.6178 16.2429 30.4528 16.7249C32.1672 17.7147 32.428 19.1695 31.0357 19.9787C29.8657 20.6586 27.8818 20.6629 26.266 20.0476L25.0662 20.7447L23.5381 19.8625L24.7378 19.1652C23.6701 18.2313 23.6636 17.0778 24.8337 16.3979L26.3618 17.2802C25.8286 17.5901 26.1001 18.2872 26.9351 18.7693C27.7773 19.2555 28.9743 19.4062 29.5076 19.0963C30.0407 18.7865 29.7768 18.0936 28.9344 17.6074C27.2274 16.6218 26.9664 15.1584 28.3514 14.3536C29.5291 13.6692 31.5127 13.6736 33.1362 14.2846L34.3283 13.5918L35.8565 14.4741Z"
                    fill="#46A046"
                  />
                  <path
                    d="M9.20469 9.28825C10.1513 9.83475 10.1563 10.7128 9.21607 11.2591C8.28277 11.8015 6.76699 11.8015 5.82033 11.2549C4.8811 10.7128 4.86861 9.83042 5.80202 9.28801C6.74225 8.74164 8.26545 8.74597 9.20469 9.28825Z"
                    fill="#46A046"
                  />
                  <path
                    d="M53.5734 23.0722C54.5201 23.6188 54.5251 24.4968 53.5845 25.0434C52.6514 25.5856 51.1281 25.59 50.1815 25.0434C49.2422 24.5011 49.2448 23.6187 50.1777 23.0765C51.1185 22.5299 52.6341 22.5299 53.5734 23.0722Z"
                    fill="#46A046"
                  />
                  <path
                    d="M43.3606 29.0078C44.3073 29.5544 44.3122 30.4323 43.372 30.9786C42.4387 31.5212 40.9229 31.521 39.9763 30.9746C39.037 30.4323 39.0319 29.5543 39.9654 29.0119C40.9056 28.4655 42.4213 28.4655 43.3606 29.0078Z"
                    fill="#46A046"
                  />
                  <path
                    d="M17.7137 1.61426L56.5882 24.0586L41.6875 32.7179L25.6756 23.4734L2.81299 10.2737L17.7137 1.61426ZM22.2912 21.4677C26.406 23.8434 33.0708 23.8391 37.1514 21.4677C41.2321 19.0963 41.2179 15.2357 37.1031 12.8599C32.9956 10.4885 26.3234 10.4887 22.2427 12.8601C18.1621 15.2315 18.1837 19.0963 22.2912 21.4677ZM9.73026 11.5475L18.1611 16.3806C18.4351 14.9259 19.5269 13.5143 21.4451 12.3995C23.3633 11.2848 25.7892 10.6522 28.3072 10.4843L19.9062 5.63392C21.1501 4.91103 21.1439 3.76609 19.9214 3.06028C18.7063 2.35867 16.7222 2.35459 15.5075 3.0604C14.293 3.76634 14.3142 4.91116 15.5293 5.61265L9.74572 9.01679C8.49341 8.29378 6.50931 8.2897 5.30227 8.99106C4.08051 9.70108 4.10179 10.8459 5.31687 11.5475C6.53937 12.2533 8.50838 12.2575 9.73026 11.5475ZM43.8645 28.7153L49.6555 25.3154C50.9078 26.0384 52.8768 26.0427 54.0914 25.3369C55.3061 24.631 55.2999 23.486 54.0773 22.7802C52.8623 22.0787 50.8857 22.0788 49.671 22.7847L41.2406 17.9513C40.9514 19.4061 39.8672 20.8134 37.949 21.9282C36.0309 23.0428 33.5974 23.6799 31.0944 23.8477L39.4955 28.698C38.2439 29.4255 38.2578 30.566 39.4729 31.2674C40.6954 31.9733 42.6644 31.9776 43.8863 31.2674C45.0932 30.5661 45.087 29.4211 43.8645 28.7153ZM23.1004 5.55661L21.9971 6.19786L26.4995 8.79723L27.6028 8.15611L23.1004 5.55661ZM45.2623 18.3517L44.1589 18.993L48.6539 21.5881L49.7573 20.947L45.2623 18.3517ZM14.1389 15.9804L15.235 15.3434L10.7327 12.7439L9.63649 13.381L14.1389 15.9804ZM36.2934 28.7714L37.3896 28.1343L32.8945 25.5391L31.7984 26.1761L36.2934 28.7714Z"
                    fill="#46A046"
                  />
                  <path
                    d="M42.9742 14.5941L25.2959 24.8675L24.4819 24.3976L42.1602 14.124L42.9742 14.5941Z"
                    fill="#86AEDC"
                  />
                  <path
                    d="M47.7223 17.335L30.044 27.6085L25.2959 24.8672L42.9742 14.5938L47.7223 17.335Z"
                    fill="#E3E6F0"
                  />
                  <path
                    d="M48.5314 17.802L30.853 28.0756L30.0439 27.6085L47.7222 17.335L48.5314 17.802Z"
                    fill="#86AEDC"
                  />
                  <path
                    d="M25.2954 24.8671L25.2584 30.5091L24.4448 30.0394L24.4819 24.3975L25.2954 24.8671Z"
                    fill="#678CC8"
                  />
                  <path
                    d="M30.0396 27.6062L30.0025 33.2482L25.2583 30.5091L25.2953 24.8672L30.0396 27.6062Z"
                    fill="#D4DBE9"
                  />
                  <path
                    d="M30.853 28.0761L30.816 33.7181L30.0024 33.2484L30.0396 27.6064L30.853 28.0761Z"
                    fill="#678CC8"
                  />
                </svg>
              </div>
            </div>
          </Col>
        </Row>
      )}
      {!isCustomer && (
        <Row>
          <Col lg="4" sm="6" className="my-2">
            <div className="cardCstm border rounded p-3 h-100 d-flex align-items-center justify-content-between gap-10">
              <div className="left">
                <p className="text-muted m-0 fw-sbold pb-2">Average Ratings</p>
                <h4 className="m-0 text-muted m-0 pt-2 fw-bold d-flex align-items-center">
                  {/* {driverData?.averageRating?.toString() || ""}{" "} */}
                  {/* <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center ms-2">
                    <li className="">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="21"
                        height="20"
                        viewBox="0 0 21 20"
                        fill="none"
                      >
                        <path
                          d="M10.6024 3.12087C10.2976 3.30557 9.91542 3.30554 9.61064 3.12082L4.93617 0.287591C4.21164 -0.151551 3.31596 0.498181 3.50848 1.32324L4.74776 6.63416C4.82827 6.97918 4.71153 7.34044 4.44435 7.57312L0.32977 11.1563C-0.307574 11.7113 0.0350516 12.7597 0.877163 12.8312L6.29958 13.2917C6.65268 13.3216 6.96029 13.5443 7.09903 13.8704L9.22706 18.8719C9.55734 19.6482 10.6576 19.6482 10.9879 18.8719L13.1159 13.8704C13.2546 13.5443 13.5623 13.3216 13.9154 13.2917L19.3378 12.8312C20.1799 12.7597 20.5225 11.7113 19.8852 11.1563L15.7706 7.57312C15.5034 7.34044 15.3867 6.97918 15.4672 6.63416L16.7065 1.32287C16.8991 0.497866 16.0035 -0.151863 15.2789 0.287164L10.6024 3.12087Z"
                          fill="#FFC500"
                        />
                      </svg>
                    </li>
                    <li className="">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="21"
                        height="20"
                        viewBox="0 0 21 20"
                        fill="none"
                      >
                        <path
                          d="M10.6024 3.12087C10.2976 3.30557 9.91542 3.30554 9.61064 3.12082L4.93617 0.287591C4.21164 -0.151551 3.31596 0.498181 3.50848 1.32324L4.74776 6.63416C4.82827 6.97918 4.71153 7.34044 4.44435 7.57312L0.32977 11.1563C-0.307574 11.7113 0.0350516 12.7597 0.877163 12.8312L6.29958 13.2917C6.65268 13.3216 6.96029 13.5443 7.09903 13.8704L9.22706 18.8719C9.55734 19.6482 10.6576 19.6482 10.9879 18.8719L13.1159 13.8704C13.2546 13.5443 13.5623 13.3216 13.9154 13.2917L19.3378 12.8312C20.1799 12.7597 20.5225 11.7113 19.8852 11.1563L15.7706 7.57312C15.5034 7.34044 15.3867 6.97918 15.4672 6.63416L16.7065 1.32287C16.8991 0.497866 16.0035 -0.151863 15.2789 0.287164L10.6024 3.12087Z"
                          fill="#FFC500"
                        />
                      </svg>
                    </li>
                    <li className="">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="21"
                        height="20"
                        viewBox="0 0 21 20"
                        fill="none"
                      >
                        <path
                          d="M10.6024 3.12087C10.2976 3.30557 9.91542 3.30554 9.61064 3.12082L4.93617 0.287591C4.21164 -0.151551 3.31596 0.498181 3.50848 1.32324L4.74776 6.63416C4.82827 6.97918 4.71153 7.34044 4.44435 7.57312L0.32977 11.1563C-0.307574 11.7113 0.0350516 12.7597 0.877163 12.8312L6.29958 13.2917C6.65268 13.3216 6.96029 13.5443 7.09903 13.8704L9.22706 18.8719C9.55734 19.6482 10.6576 19.6482 10.9879 18.8719L13.1159 13.8704C13.2546 13.5443 13.5623 13.3216 13.9154 13.2917L19.3378 12.8312C20.1799 12.7597 20.5225 11.7113 19.8852 11.1563L15.7706 7.57312C15.5034 7.34044 15.3867 6.97918 15.4672 6.63416L16.7065 1.32287C16.8991 0.497866 16.0035 -0.151863 15.2789 0.287164L10.6024 3.12087Z"
                          fill="#FFC500"
                        />
                      </svg>
                    </li>
                    <li className="">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="21"
                        height="20"
                        viewBox="0 0 21 20"
                        fill="none"
                      >
                        <g clip-path="url(#clip0_22_5773)">
                          <path
                            d="M10.724 3.12087C10.4192 3.30557 10.037 3.30554 9.73223 3.12082L5.05775 0.287591C4.33322 -0.151551 3.43754 0.498181 3.63006 1.32324L4.86934 6.63416C4.94985 6.97918 4.83311 7.34044 4.56593 7.57312L0.451352 11.1563C-0.185992 11.7113 0.156634 12.7597 0.998745 12.8312L6.42116 13.2917C6.77426 13.3216 7.08187 13.5443 7.22061 13.8704L9.34864 18.8719C9.67892 19.6482 10.7792 19.6482 11.1095 18.8719L13.2375 13.8704C13.3762 13.5443 13.6838 13.3216 14.0369 13.2917L19.4594 12.8312C20.3015 12.7597 20.6441 11.7113 20.0067 11.1563L15.8922 7.57312C15.625 7.34044 15.5083 6.97918 15.5888 6.63416L16.8281 1.32287C17.0206 0.497866 16.1251 -0.151863 15.4005 0.287164L10.724 3.12087Z"
                            fill="#E0E8F1"
                          />
                          <mask
                            id="mask0_22_5773"
                            style={{ maskType: "alpha" }}
                            maskUnits="userSpaceOnUse"
                            x="0"
                            y="0"
                            width="21"
                            height="20"
                          >
                            <path
                              d="M10.724 3.12087C10.4192 3.30557 10.037 3.30554 9.73223 3.12082L5.05775 0.287591C4.33322 -0.151551 3.43754 0.498181 3.63006 1.32324L4.86934 6.63416C4.94985 6.97918 4.83311 7.34044 4.56593 7.57312L0.451352 11.1563C-0.185992 11.7113 0.156634 12.7597 0.998745 12.8312L6.42116 13.2917C6.77426 13.3216 7.08187 13.5443 7.22061 13.8704L9.34864 18.8719C9.67892 19.6482 10.7792 19.6482 11.1095 18.8719L13.2375 13.8704C13.3762 13.5443 13.6838 13.3216 14.0369 13.2917L19.4594 12.8312C20.3015 12.7597 20.6441 11.7113 20.0067 11.1563L15.8922 7.57312C15.625 7.34044 15.5083 6.97918 15.5888 6.63416L16.8281 1.32287C17.0206 0.497866 16.1251 -0.151863 15.4005 0.287164L10.724 3.12087Z"
                              fill="#E0E8F1"
                            />
                          </mask>
                          <g mask="url(#mask0_22_5773)">
                            <rect
                              width="10.1075"
                              height="19.3061"
                              transform="matrix(1 0 0 -1 0.121582 19.4541)"
                              fill="#FFC500"
                            />
                          </g>
                        </g>
                        <defs>
                          <clipPath id="clip0_22_5773">
                            <rect
                              width="20.2149"
                              height="19.3726"
                              fill="white"
                              transform="matrix(1 0 0 -1 0.121582 19.4541)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                    </li>
                    <li className="">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="22"
                        height="20"
                        viewBox="0 0 22 20"
                        fill="none"
                      >
                        <g clip-path="url(#clip0_22_5777)">
                          <path
                            d="M11.431 3.49587C11.1262 3.68057 10.744 3.68054 10.4393 3.49582L5.76478 0.662591C5.04025 0.223449 4.14457 0.873181 4.33709 1.69824L5.57637 7.00916C5.65688 7.35418 5.54014 7.71544 5.27296 7.94812L1.15838 11.5313C0.521039 12.0863 0.863665 13.1347 1.70578 13.2062L7.12819 13.6667C7.48129 13.6966 7.7889 13.9193 7.92765 14.2454L10.0557 19.2469C10.386 20.0232 11.4862 20.0232 11.8165 19.2469L13.9445 14.2454C14.0833 13.9193 14.3909 13.6966 14.744 13.6667L20.1664 13.2062C21.0085 13.1347 21.3511 12.0863 20.7138 11.5313L16.5992 7.94812C16.332 7.71544 16.2153 7.35418 16.2958 7.00916L17.5352 1.69787C17.7277 0.872866 16.8321 0.223137 16.1076 0.662164L11.431 3.49587Z"
                            fill="#E0E8F1"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_22_5777">
                            <rect
                              width="20.2149"
                              height="19.3726"
                              fill="white"
                              transform="matrix(1 0 0 -1 0.828613 19.4541)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                    </li>
                  </ul> */}
                     {averageRating}
                     <StarRating averageRating={averageRating} />
                </h4>
              </div>
              <div className="imgWrp">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="56"
                  height="50"
                  viewBox="0 0 56 50"
                  fill="none"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M39.2375 49C40.7495 49 44.7815 47.5006 43.4375 46.3225C43.3255 46.2689 43.2695 46.2154 43.2135 46.1618V21.1003C43.7735 20.8326 43.8855 19.9222 43.1575 19.708C32.8536 16.495 27.3657 14.353 24.3978 3.58942C22.4938 -3.74696 10.2859 -0.212643 19.6378 17.6731H5.41402C0.822086 17.6731 -1.02589 23.4566 2.83805 25.8663C0.0380974 27.6335 0.0380974 31.5426 2.83805 33.3098C0.0380974 35.0769 0.0380974 39.0397 2.83805 40.8068C-1.02589 43.2166 0.822086 49 5.41402 49H39.2375Z"
                    fill="#FFC3A1"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M45.485 50H50.3604C53.0751 50 55.2358 47.824 55.2358 45.1584V20.8416C55.2358 18.176 53.0751 16.0544 50.3604 16.0544L45.485 16C43.9337 16 42.6594 17.2512 42.6594 18.7744V47.2256C42.6594 48.7488 43.9337 50 45.485 50Z"
                    fill="#2882B0"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M48.968 46C53.1331 46 53.1331 40 48.968 40C44.7488 40 44.7488 46 48.968 46Z"
                    fill="#20698E"
                  />
                </svg>
              </div>
            </div>
          </Col>
          <Col lg="4" sm="6" className="my-2">
            <div className="cardCstm border rounded p-3 h-100 d-flex align-items-center justify-content-between gap-10">
              <div className="left">
                <p className="text-muted m-0 fw-sbold pb-2">
                  Booking Completed
                </p>
                <h4 className="m-0 text-muted m-0 pt-2 fw-bold d-flex align-items-center">
                  {driverData?.totalCompletedBookings?.toString() || ""}
                </h4>
              </div>
              <div className="imgWrp">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="55"
                  height="54"
                  viewBox="0 0 55 54"
                  fill="none"
                >
                  <path
                    d="M27.4102 54C12.4985 54 0.410156 41.9117 0.410156 27C0.410156 12.0883 12.4985 0 27.4102 0C42.3218 0 54.4102 12.0883 54.4102 27C54.4102 41.9117 42.3218 54 27.4102 54Z"
                    fill="#6DC871"
                  />
                  <path
                    d="M38.7619 15.3211C39.1983 14.893 39.9058 14.893 40.3422 15.3211L45.0829 19.9725C45.5192 20.4006 45.5192 21.0948 45.0829 21.5229L24.5398 41.6789C24.1034 42.107 23.3959 42.107 22.9596 41.6789L8.73743 27.7248C8.30106 27.2966 8.30106 26.6025 8.73743 26.1743L13.4781 21.5229C13.9145 21.0948 14.622 21.0948 15.0584 21.5229L23.7497 30.0505L38.7619 15.3211Z"
                    fill="white"
                  />
                </svg>
              </div>
            </div>
          </Col>
          <Col lg="4" sm="6" className="my-2">
            <div className="cardCstm border rounded p-3 h-100 d-flex align-items-center justify-content-between gap-10">
              <div className="left">
                <p className="text-muted m-0 fw-sbold pb-2">Total Earnings</p>
                <h4 className="m-0 text-muted m-0 pt-2 fw-bold d-flex align-items-center">
                  ${driverData?.totalEarnings?.toString() || ""}
                </h4>
              </div>
              <div className="imgWrp">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="60"
                  height="50"
                  viewBox="0 0 60 50"
                  fill="none"
                >
                  <path
                    d="M59.3748 34.0859L59.356 39.7263L41.6777 49.9997L41.6965 44.3595L59.3748 34.0859Z"
                    fill="#5EAF5F"
                  />
                  <path
                    d="M41.6963 44.3593L41.6775 49.9995L0 25.9371L0.0189257 20.2969L41.6963 44.3593Z"
                    fill="#7BC578"
                  />
                  <path
                    d="M59.3748 34.0859L41.6965 44.3594L0.019043 20.297L17.6973 10.0234L59.3748 34.0859Z"
                    fill="#98D095"
                  />
                  <path
                    d="M44.2636 33.0662L43.7823 33.3459C44.2079 33.729 44.2107 34.1937 43.7365 34.4693L43.1178 34.1121C43.3328 33.9871 43.227 33.7031 42.8916 33.5094C42.5487 33.3115 42.0581 33.2511 41.8431 33.3761C41.6285 33.5008 41.7339 33.785 42.0768 33.9831C42.77 34.3832 42.8703 34.9726 42.3073 35.2998C41.8332 35.5754 41.0309 35.5753 40.3754 35.3258L39.894 35.6055L39.2754 35.2484L39.7567 34.9686C39.3239 34.5897 39.321 34.1249 39.7952 33.8495L40.4139 34.2067C40.1989 34.3316 40.3119 34.6113 40.6547 34.8094C40.9902 35.0031 41.4736 35.0675 41.6886 34.9426C41.9108 34.8134 41.7975 34.5339 41.462 34.3403C40.7688 33.94 40.6614 33.346 41.2244 33.0188C41.6985 32.7434 42.5008 32.7435 43.1636 32.9888L43.6449 32.709L44.2636 33.0662Z"
                    fill="#46A046"
                  />
                  <path
                    d="M20.1187 19.1258L19.6373 19.4055C20.0629 19.7886 20.0732 20.2576 19.5991 20.5331L18.9729 20.1715C19.1878 20.0467 19.0895 19.7669 18.7467 19.569C18.4038 19.371 17.9131 19.3107 17.6982 19.4357C17.4836 19.5603 17.5889 19.8446 17.9319 20.0425C18.6251 20.4428 18.7328 21.0365 18.1699 21.3636C17.6957 21.6392 16.8859 21.6349 16.2304 21.3854L15.7491 21.665L15.1304 21.3078L15.6118 21.0281C15.1789 20.6492 15.1761 20.1845 15.6503 19.9089L16.269 20.2662C16.054 20.3911 16.167 20.6709 16.5098 20.8689C16.8527 21.0668 17.3287 21.1271 17.5437 21.0022C17.7659 20.873 17.66 20.5978 17.3171 20.3997C16.6238 19.9995 16.5165 19.4056 17.0795 19.0784C17.5536 18.8029 18.3559 18.8029 19.0185 19.0482L19.5 18.7686L20.1187 19.1258Z"
                    fill="#46A046"
                  />
                  <path
                    d="M19.4174 13.3761C20.3642 13.9227 20.3691 14.8006 19.4285 15.3474C18.4956 15.8895 16.9722 15.8938 16.0255 15.3474C15.0863 14.8051 15.0815 13.9184 16.0144 13.3761C16.955 12.8295 18.4782 12.8338 19.4174 13.3761Z"
                    fill="#46A046"
                  />
                  <path
                    d="M35.8565 24.4976L34.6644 25.1904C35.7245 26.1288 35.7312 27.2735 34.5534 27.9579L33.0253 27.0755C33.5584 26.7657 33.2945 26.0729 32.4521 25.5865C31.6172 25.1044 30.4127 24.9496 29.8795 25.2593C29.3464 25.5692 29.6178 26.2663 30.4528 26.7484C32.1672 27.7383 32.428 29.193 31.0357 30.0021C29.8657 30.6821 27.8818 30.6864 26.266 30.071L25.0662 30.7681L23.5381 29.8859L24.7378 29.1887C23.6701 28.2547 23.6636 27.1013 24.8337 26.4213L26.3618 27.3036C25.8286 27.6135 26.1001 28.3107 26.9351 28.7927C27.7773 29.279 28.9743 29.4297 29.5076 29.1199C30.0407 28.81 29.7768 28.1171 28.9344 27.6308C27.2274 26.6452 26.9664 25.182 28.3514 24.3771C29.5291 23.6927 31.5127 23.6971 33.1362 24.3081L34.3283 23.6152L35.8565 24.4976Z"
                    fill="#46A046"
                  />
                  <path
                    d="M9.20469 19.3117C10.1513 19.8583 10.1563 20.7362 9.21607 21.2826C8.28277 21.825 6.76699 21.825 5.82033 21.2785C4.8811 20.7362 4.86861 19.8539 5.80202 19.3114C6.74225 18.7651 8.26545 18.7694 9.20469 19.3117Z"
                    fill="#46A046"
                  />
                  <path
                    d="M53.5734 33.0956C54.5201 33.6422 54.5251 34.5203 53.5845 35.0669C52.6514 35.609 51.1281 35.6135 50.1815 35.0669C49.2422 34.5246 49.2448 33.6422 50.1777 33.1C51.1185 32.5533 52.6341 32.5533 53.5734 33.0956Z"
                    fill="#46A046"
                  />
                  <path
                    d="M43.3606 39.0312C44.3073 39.5778 44.3122 40.4558 43.372 41.0022C42.4387 41.5446 40.9229 41.5446 39.9763 40.998C39.037 40.4557 39.0319 39.5777 39.9654 39.0353C40.9056 38.4889 42.4213 38.4889 43.3606 39.0312Z"
                    fill="#46A046"
                  />
                  <path
                    d="M17.7137 11.6377L56.5882 34.0819L41.6875 42.7412L25.6756 33.4967L2.81299 20.297L17.7137 11.6377ZM22.2912 31.4911C26.406 33.8667 33.0708 33.8624 37.1514 31.491C41.2321 29.1196 41.2179 25.259 37.1031 22.8834C32.9956 20.512 26.3234 20.512 22.2427 22.8834C18.1621 25.2548 18.1837 29.1197 22.2912 31.4911ZM9.73026 21.5708L18.1611 26.4039C18.4351 24.9494 19.5269 23.5376 21.4451 22.4229C23.3633 21.3081 25.7892 20.6756 28.3072 20.5076L19.9062 15.6572C21.1501 14.9343 21.1439 13.7894 19.9214 13.0836C18.7063 12.3821 16.7222 12.3779 15.5075 13.0837C14.293 13.7897 14.3142 14.9345 15.5293 15.636L9.74572 19.0402C8.49341 18.3171 6.50931 18.313 5.30227 19.0144C4.08051 19.7245 4.10179 20.8693 5.31687 21.5708C6.53937 22.2766 8.50838 22.281 9.73026 21.5708ZM43.8645 38.7386L49.6555 35.3387C50.9078 36.0617 52.8768 36.066 54.0914 35.3602C55.3061 34.6543 55.2999 33.5093 54.0773 32.8035C52.8623 32.102 50.8857 32.1022 49.671 32.8081L41.2406 27.9747C40.9514 29.4296 39.8672 30.8367 37.949 31.9515C36.0309 33.0662 33.5974 33.7032 31.0944 33.871L39.4955 38.7214C38.2439 39.4488 38.2578 40.5893 39.4729 41.2907C40.6954 41.9966 42.6644 42.0009 43.8863 41.2909C45.0932 40.5894 45.087 39.4444 43.8645 38.7386ZM23.1004 15.5799L21.9971 16.2212L26.4995 18.8207L27.6028 18.1794L23.1004 15.5799ZM45.2623 28.3752L44.1589 29.0163L48.6539 31.6114L49.7573 30.9703L45.2623 28.3752ZM14.1389 26.0038L15.235 25.3667L10.7327 22.7673L9.63649 23.4043L14.1389 26.0038ZM36.2934 38.7947L37.3896 38.1576L32.8945 35.5625L31.7984 36.1995L36.2934 38.7947Z"
                    fill="#46A046"
                  />
                  <path
                    d="M42.9742 24.6175L25.2959 34.8909L24.4819 34.421L42.1602 24.1475L42.9742 24.6175Z"
                    fill="#86AEDC"
                  />
                  <path
                    d="M47.7223 27.3584L30.044 37.632L25.2959 34.8906L42.9742 24.6172L47.7223 27.3584Z"
                    fill="#E3E6F0"
                  />
                  <path
                    d="M48.5314 27.8255L30.853 38.099L30.0439 37.6319L47.7222 27.3584L48.5314 27.8255Z"
                    fill="#86AEDC"
                  />
                  <path
                    d="M25.2954 34.8906L25.2584 40.5325L24.4448 40.0628L24.4819 34.4209L25.2954 34.8906Z"
                    fill="#678CC8"
                  />
                  <path
                    d="M30.0396 37.6298L30.0025 43.2716L25.2583 40.5326L25.2953 34.8906L30.0396 37.6298Z"
                    fill="#D4DBE9"
                  />
                  <path
                    d="M30.853 38.0994L30.816 43.7414L30.0024 43.2717L30.0396 37.6299L30.853 38.0994Z"
                    fill="#678CC8"
                  />
                  <path
                    d="M59.3748 24.0625L59.356 29.7027L41.6777 39.9763L41.6965 34.336L59.3748 24.0625Z"
                    fill="#5EAF5F"
                  />
                  <path
                    d="M41.6963 34.336L41.6775 39.9762L0 15.9138L0.0189257 10.2734L41.6963 34.336Z"
                    fill="#7BC578"
                  />
                  <path
                    d="M59.3748 24.0624L41.6965 34.336L0.019043 10.2734L17.6973 0L59.3748 24.0624Z"
                    fill="#98D095"
                  />
                  <path
                    d="M44.2636 23.0428L43.7823 23.3225C44.2079 23.7056 44.2107 24.1703 43.7365 24.4458L43.1178 24.0886C43.3328 23.9637 43.227 23.6797 42.8916 23.486C42.5487 23.2881 42.0581 23.2277 41.8431 23.3526C41.6285 23.4773 41.7339 23.7616 42.0768 23.9595C42.77 24.3598 42.8703 24.9492 42.3073 25.2764C41.8332 25.5519 41.0309 25.5519 40.3754 25.3024L39.894 25.582L39.2754 25.2248L39.7567 24.9451C39.3239 24.5662 39.321 24.1015 39.7952 23.826L40.4139 24.1831C40.1989 24.3081 40.3119 24.5879 40.6547 24.7859C40.9902 24.9795 41.4736 25.0441 41.6886 24.9191C41.9108 24.79 41.7975 24.5105 41.462 24.3167C40.7688 23.9166 40.6614 23.3226 41.2244 22.9954C41.6985 22.7199 42.5008 22.7199 43.1636 22.9652L43.6449 22.6855L44.2636 23.0428Z"
                    fill="#46A046"
                  />
                  <path
                    d="M20.1187 9.10223L19.6373 9.38203C20.0629 9.765 20.0732 10.2341 19.5991 10.5097L18.9729 10.1481C19.1878 10.0232 19.0895 9.74348 18.7467 9.54556C18.4038 9.34752 17.9131 9.28728 17.6982 9.41222C17.4836 9.5369 17.5889 9.82103 17.9319 10.0191C18.6251 10.4194 18.7328 11.0131 18.1699 11.3402C17.6957 11.6158 16.8859 11.6113 16.2304 11.3618L15.7491 11.6416L15.1304 11.2844L15.6118 11.0046C15.1789 10.6258 15.1761 10.1611 15.6503 9.88548L16.269 10.2427C16.054 10.3677 16.167 10.6475 16.5098 10.8454C16.8527 11.0434 17.3287 11.1036 17.5437 10.9787C17.7659 10.8496 17.66 10.5742 17.3171 10.3763C16.6238 9.97603 16.5165 9.38203 17.0795 9.05498C17.5536 8.77938 18.3559 8.7795 19.0185 9.0248L19.5 8.74512L20.1187 9.10223Z"
                    fill="#46A046"
                  />
                  <path
                    d="M19.4174 3.35268C20.3642 3.8993 20.3691 4.77717 19.4285 5.32379C18.4956 5.86596 16.9722 5.87041 16.0255 5.32392C15.0863 4.78163 15.0815 3.89484 16.0144 3.35268C16.955 2.80606 18.4782 2.81039 19.4174 3.35268Z"
                    fill="#46A046"
                  />
                  <path
                    d="M35.8565 14.4741L34.6644 15.167C35.7245 16.1052 35.7312 17.25 34.5534 17.9343L33.0253 17.0521C33.5584 16.7422 33.2945 16.0494 32.4521 15.563C31.6172 15.081 30.4127 14.926 29.8795 15.2359C29.3464 15.5457 29.6178 16.2429 30.4528 16.7249C32.1672 17.7147 32.428 19.1695 31.0357 19.9787C29.8657 20.6586 27.8818 20.6629 26.266 20.0476L25.0662 20.7447L23.5381 19.8625L24.7378 19.1652C23.6701 18.2313 23.6636 17.0778 24.8337 16.3979L26.3618 17.2802C25.8286 17.5901 26.1001 18.2872 26.9351 18.7693C27.7773 19.2555 28.9743 19.4062 29.5076 19.0963C30.0407 18.7865 29.7768 18.0936 28.9344 17.6074C27.2274 16.6218 26.9664 15.1584 28.3514 14.3536C29.5291 13.6692 31.5127 13.6736 33.1362 14.2846L34.3283 13.5918L35.8565 14.4741Z"
                    fill="#46A046"
                  />
                  <path
                    d="M9.20469 9.28825C10.1513 9.83475 10.1563 10.7128 9.21607 11.2591C8.28277 11.8015 6.76699 11.8015 5.82033 11.2549C4.8811 10.7128 4.86861 9.83042 5.80202 9.28801C6.74225 8.74164 8.26545 8.74597 9.20469 9.28825Z"
                    fill="#46A046"
                  />
                  <path
                    d="M53.5734 23.0722C54.5201 23.6188 54.5251 24.4968 53.5845 25.0434C52.6514 25.5856 51.1281 25.59 50.1815 25.0434C49.2422 24.5011 49.2448 23.6187 50.1777 23.0765C51.1185 22.5299 52.6341 22.5299 53.5734 23.0722Z"
                    fill="#46A046"
                  />
                  <path
                    d="M43.3606 29.0078C44.3073 29.5544 44.3122 30.4323 43.372 30.9786C42.4387 31.5212 40.9229 31.521 39.9763 30.9746C39.037 30.4323 39.0319 29.5543 39.9654 29.0119C40.9056 28.4655 42.4213 28.4655 43.3606 29.0078Z"
                    fill="#46A046"
                  />
                  <path
                    d="M17.7137 1.61426L56.5882 24.0586L41.6875 32.7179L25.6756 23.4734L2.81299 10.2737L17.7137 1.61426ZM22.2912 21.4677C26.406 23.8434 33.0708 23.8391 37.1514 21.4677C41.2321 19.0963 41.2179 15.2357 37.1031 12.8599C32.9956 10.4885 26.3234 10.4887 22.2427 12.8601C18.1621 15.2315 18.1837 19.0963 22.2912 21.4677ZM9.73026 11.5475L18.1611 16.3806C18.4351 14.9259 19.5269 13.5143 21.4451 12.3995C23.3633 11.2848 25.7892 10.6522 28.3072 10.4843L19.9062 5.63392C21.1501 4.91103 21.1439 3.76609 19.9214 3.06028C18.7063 2.35867 16.7222 2.35459 15.5075 3.0604C14.293 3.76634 14.3142 4.91116 15.5293 5.61265L9.74572 9.01679C8.49341 8.29378 6.50931 8.2897 5.30227 8.99106C4.08051 9.70108 4.10179 10.8459 5.31687 11.5475C6.53937 12.2533 8.50838 12.2575 9.73026 11.5475ZM43.8645 28.7153L49.6555 25.3154C50.9078 26.0384 52.8768 26.0427 54.0914 25.3369C55.3061 24.631 55.2999 23.486 54.0773 22.7802C52.8623 22.0787 50.8857 22.0788 49.671 22.7847L41.2406 17.9513C40.9514 19.4061 39.8672 20.8134 37.949 21.9282C36.0309 23.0428 33.5974 23.6799 31.0944 23.8477L39.4955 28.698C38.2439 29.4255 38.2578 30.566 39.4729 31.2674C40.6954 31.9733 42.6644 31.9776 43.8863 31.2674C45.0932 30.5661 45.087 29.4211 43.8645 28.7153ZM23.1004 5.55661L21.9971 6.19786L26.4995 8.79723L27.6028 8.15611L23.1004 5.55661ZM45.2623 18.3517L44.1589 18.993L48.6539 21.5881L49.7573 20.947L45.2623 18.3517ZM14.1389 15.9804L15.235 15.3434L10.7327 12.7439L9.63649 13.381L14.1389 15.9804ZM36.2934 28.7714L37.3896 28.1343L32.8945 25.5391L31.7984 26.1761L36.2934 28.7714Z"
                    fill="#46A046"
                  />
                  <path
                    d="M42.9742 14.5941L25.2959 24.8675L24.4819 24.3976L42.1602 14.124L42.9742 14.5941Z"
                    fill="#86AEDC"
                  />
                  <path
                    d="M47.7223 17.335L30.044 27.6085L25.2959 24.8672L42.9742 14.5938L47.7223 17.335Z"
                    fill="#E3E6F0"
                  />
                  <path
                    d="M48.5314 17.802L30.853 28.0756L30.0439 27.6085L47.7222 17.335L48.5314 17.802Z"
                    fill="#86AEDC"
                  />
                  <path
                    d="M25.2954 24.8671L25.2584 30.5091L24.4448 30.0394L24.4819 24.3975L25.2954 24.8671Z"
                    fill="#678CC8"
                  />
                  <path
                    d="M30.0396 27.6062L30.0025 33.2482L25.2583 30.5091L25.2953 24.8672L30.0396 27.6062Z"
                    fill="#D4DBE9"
                  />
                  <path
                    d="M30.853 28.0761L30.816 33.7181L30.0024 33.2484L30.0396 27.6064L30.853 28.0761Z"
                    fill="#678CC8"
                  />
                </svg>
              </div>
            </div>
          </Col>
        </Row>
      )}
    </>
  );
};

export default CustomerCounter;
